import ValidateDefaults from 'validation/ValidateDefaults';

export default class ValidateZip extends ValidateDefaults {
    constructor(obj) {
        obj = obj ? obj : {};
        super(obj);
        this.message = obj.message ? obj.message : 'Required';
        this.on = obj.on && Array.isArray(obj.on) ? obj.on : ['blur'];
        this.pageAttrKey = 'validation_zip';
    }

    validate(zip) {
        if (!zip) {
            return false;
        }
        const re = /^[0-9]{5}$/;
        return re.test(zip);
    }

    static defaultMessage() {
        return '%s is invalid';
    }
}
